module.exports = __webpack_public_path__ + "static/media/1POLICY3.4ca0ff23.jpg";